import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewEncapsulation,
    ViewChild,
    signal,
    computed,
    effect,
    ChangeDetectionStrategy,
    inject,
} from "@angular/core";
import { Task } from "../../pojo/Task";
import { EventIncludeOption, EventService, EventData } from "../../services/event.service";
import { S25Util } from "../../util/s25-util";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { ContactService } from "../../services/contact.service";
import { UserprefService } from "../../services/userpref.service";
import { S25ItemI } from "../../pojo/S25ItemI";
import { Bind } from "../../decorators/bind.decorator";
import { S25ItemComponent } from "../s25-item/s25.item.component";
import { S25TableModule } from "../s25-table/s25.table.module";
import { S25ModalComponent } from "../s25-modal/s25.modal.component";
import { S25ModalModule } from "../s25-modal/s25.modal.module";
import { Table } from "../s25-table/Table";
import { GenericTableButtonComponent } from "../s25-table/generics/generic.table.button.component";
import { CacheRepository } from "../../decorators/cache.decorator";
import { S25EditableModule } from "../s25-editable/s25.editable.module";
import { S25EditableDateComponent } from "../s25-editable/s25-editable-date/s25.editable.date.component";
import { S25TaskActionComponent } from "./s25.task.action.component";
import { S25TaskStatusComponent } from "./s25.task.status.component";
import { TaskUtil } from "./task.util";
import { TaskCompetingUtil } from "./task.competing.util";
import { SpaceService } from "../../services/space.service";
import { Item } from "../../pojo/Item";
import { S25TaskModule } from "./s25.task.module";
import { S25CheckboxModule } from "../s25-checkbox/s25.checkbox.module";
import { EventReqInfo } from "../../services/avail.service";
import { S25DropdownPaginatedModule } from "../s25-dropdown/s25.dropdown.paginated.module";
import { S25TableComponent } from "../s25-table/s25.table.component";
import { Proto } from "../../pojo/Proto";
import CharBoolean = Proto.CharBoolean;
import { S25Datefilter } from "../s25-dateformat/s25.datefilter.service";
import { jSith } from "../../util/jquery-replacement";
import { TaskChange, TaskService } from "../../services/task/task.service";
import { S25LoadingApi } from "../s25-loading/loading.api";
import { S25RadioModule } from "../s25-radio/s25.radio.module";
import { S25ItemModule } from "../s25-item/s25.item.module";
import { S25InfoMessageModule } from "../s25-info-message/s25.info.message.module";
import { S25TaskCompetingConfirmationComponent } from "./s25.task.competing.confirmation.component";
import { S25SimpleCollapseModule } from "../s25-simple-collapse/s25.simple.collapse.module";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { TelemetryService } from "../../services/telemetry.service";
import { TaskTimeComponent } from "./task.time.component";
import ISODateString = Proto.ISODateString;
import { WaitlistEntry } from "../../pojo/Waitlist";
import { WaitlistStore } from "../../stores/waitlist.store";
export interface ManageTaskData {
    eventIds?: number[];
    itemIds?: number[];
    viewMode?: "daily" | "weekly";
    taskId?: number;
    dateRang?: {};
    waitlistEvents?: EventReqInfo[];
}

export enum GroupingMode {
    None = "none",
    Conflicts = "conflicts",
    Events = "events",
}

@TypeManagerDecorator("s25-ng-manage-task")
@Component({
    selector: "s25-ng-manage-task",
    template: `
        @if (isInit()) {
            <div class="view-wrapper">
                <div class="filter-group">
                    <label for="viewModeDropdown" class="filter-label">View:</label>
                    <s25-generic-dropdown
                        id="viewModeDropdown"
                        [items]="viewModes"
                        [(value)]="chosenViewMode"
                        (valueChange)="onChangeViewMode($event)"
                        [ariaLabel]="'Select view mode'"
                    />
                </div>
                <div class="filter-group">
                    <label for="eventFilterDropdown" class="filter-label">Filter by Event:</label>
                    <s25-generic-dropdown
                        id="eventFilterDropdown"
                        [items]="data.waitlistEvents"
                        [placeholder]="'All Events'"
                        [staticItems]="staticItems"
                        [value]="chosenEvent()"
                        (valueChange)="onChangeEventChoosen($event)"
                        [ariaLabel]="'Filter by event'"
                    />
                </div>
                <div class="filter-group">
                    <label for="dateFilterDropdown" class="filter-label">Filter by Date:</label>
                    <s25-generic-dropdown
                        id="dateFilterDropdown"
                        [items]="datesList"
                        [placeholder]="'All Dates'"
                        [staticItems]="staticDateItems"
                        [(value)]="chosenDate"
                        (valueChange)="onChangeDateChoosen($event)"
                        [ariaLabel]="'Filter by date'"
                    />
                </div>
            </div>

            @if (taskItemsInit() && taskItemsToDisplay().length > 0) {
                <div class="c-margin-bottom--single c-margin-top--single">
                    <button
                        class="aw-button aw-button--primary c-margin-right--single"
                        (click)="approve()"
                        [disabled]="selectedItems().length === 0"
                    >
                        Approve Checked
                    </button>
                    <button
                        class="aw-button aw-button--primary"
                        (click)="deny()"
                        [disabled]="selectedItems().length === 0"
                    >
                        Deny Checked
                    </button>
                </div>
            }

            <s25-task-competing-confirmation
                [show]="showWaitlistConfirm()"
                [message]="competingMessage()"
                [count]="pendingCompetingInfo()?.count || 0"
                (confirm)="handleCompetingConfirm($event)"
                (cancel)="cancelCompetingConfirm()"
                [inline]="true"
            ></s25-task-competing-confirmation>
            <div class="c-margin-top--half grouping-wrapper">
                <span class="grouping-label">Group by:</span>
                <s25-ng-radio
                    [name]="'groupingMode'"
                    [radioValue]="GroupingMode.None"
                    [value]="groupingMode()"
                    (valueChange)="onChangeGroupingMode($event)"
                    [ariaLabel]="'No groups'"
                >
                    No groups
                </s25-ng-radio>
                <s25-ng-radio
                    [name]="'groupingMode'"
                    [radioValue]="GroupingMode.Conflicts"
                    [value]="groupingMode()"
                    (valueChange)="onChangeGroupingMode($event)"
                    [ariaLabel]="'Group by conflicts'"
                >
                    Group by conflicts
                </s25-ng-radio>
                <s25-ng-radio
                    [name]="'groupingMode'"
                    [radioValue]="GroupingMode.Events"
                    [value]="groupingMode()"
                    (valueChange)="onChangeGroupingMode($event)"
                    [ariaLabel]="'Group by event'"
                >
                    Group by event
                </s25-ng-radio>
            </div>

            @if (showQueueInfo()) {
                <s25-simple-collapse [expanded]="false" [header]="'Understanding the Waitlist'">
                    <div class="waitlist-info-content">
                        <ul style="margin-top: 8px; margin-bottom: 0; padding-left: 20px;">
                            <li>
                                <strong>Waitlist Order:</strong> This request's position in line (e.g., "2nd" means one
                                request is ahead)
                            </li>
                            <li>
                                <strong>Total Waitlisted:</strong> Total number of requests competing for this space at
                                this time
                            </li>
                            <li>Requests are processed first-come, first-served based on submission time</li>
                        </ul>
                    </div>
                </s25-simple-collapse>
            }

            @if (sharedLocationInfo()?.hasSharedLocations) {
                <s25-ng-icon
                    [type]="'info'"
                    [ariaLabel]="'Shared Space Information'"
                    class="c-margin-right--single c-margin-top--single"
                ></s25-ng-icon>
                <span class="shared-location-message c-margin-top--single">{{ sharedLocationInfo().message }}</span>
            }
            <div class="c-margin-top--single c-margin-bottom--half">
                <s25-ng-table
                    [dataSource]="tableData"
                    [hasRefresh]="true"
                    [hasFilter]="true"
                    [columnSortable]="true"
                    [pivotThreshold]="0"
                    [hasSelect]="true"
                    [hasSelectAll]="groupingMode() === 'none'"
                    (selectedChange)="selectedChange($event)"
                    [hasExpandableRows]="true"
                    [noResultsMessage]="'No Overlapping Requests'"
                ></s25-ng-table>
            </div>

            <s25-ng-modal #deleteNonApTasksModal [title]="'Confirm Deletion'" [type]="'deny'" [size]="'xs'">
                Are you sure that you want to delete this waitlist?
            </s25-ng-modal>
        }
    `,
    styles: `
        .view-wrapper {
            display: flex;
            align-items: flex-start;
            flex-wrap: wrap;
            gap: 20px;
            margin-bottom: 16px;
        }

        .filter-group {
            display: flex;
            flex-direction: column;
            gap: 8px;
            flex: 1 1 calc(33.333% - 14px);
            min-width: 200px;
        }

        .filter-label {
            font-weight: 600;
            font-size: 14px;
            color: #333;
            margin: 0;
        }

        ::ng-deep .nm-party--on .filter-label {
            color: #e5e5e5;
        }

        .filter-group s25-generic-dropdown {
            width: 100%;
        }

        :host ::ng-deep .filter-group s25-generic-dropdown .dropdown-container {
            width: 100%;
        }

        :host ::ng-deep .filter-group s25-generic-dropdown .dropdown-toggle {
            width: 100%;
            text-align: left;
        }

        .grouping-wrapper {
            display: flex;
            align-items: center;
            gap: 20px;
            padding: 12px 16px;
            background-color: #f8f9fa;
            border-radius: 4px;
        }

        .grouping-label {
            font-weight: 600;
            color: #333;
        }

        ::ng-deep .nm-party--on .grouping-wrapper {
            background-color: #2a2b32;
        }

        ::ng-deep .nm-party--on .grouping-label {
            color: #e5e5e5;
        }

        /* Conflict child row styling - rows rendered directly in table */
        :host ::ng-deep .child-row {
            border-left: 4px solid #6c757d;
        }

        :host ::ng-deep .child-row:hover {
            background-color: #e5e5e5;
        }

        :host ::ng-deep .child-row td {
            padding: 0.75em 1em;
            vertical-align: middle;
        }

        /* Dark mode support */
        :host-context(#s25.nm-party--on) :host ::ng-deep .child-row {
            background-color: #2a2b32;
            border-left-color: #495057;
        }

        :host-context(#s25.nm-party--on) :host ::ng-deep .child-row:hover {
            background-color: #343541;
        }

        :host-context(#s25.nm-party--on) :host ::ng-deep .conflict-item-row {
            background-color: rgba(240, 224, 155, 1) !important;
        }

        /* fixed action buttons not squished */
        :host ::ng-deep s25-ng-task-action .taskStateChoice {
            overflow-wrap: normal;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        S25TableModule,
        S25EditableModule,
        S25TaskModule,
        S25CheckboxModule,
        S25DropdownPaginatedModule,
        S25RadioModule,
        S25ItemModule,
        S25InfoMessageModule,
        S25TaskCompetingConfirmationComponent,
        S25SimpleCollapseModule,
        S25IconComponent,
        S25ModalModule,
    ],
})
export class ManageTaskComponent implements OnInit {
    @ViewChild(S25TableComponent) tableComponent: S25TableComponent;
    @ViewChild("deleteNonApTasksModal") deleteNonApTasksModal: S25ModalComponent;
    @Input() data!: ManageTaskData;
    @Input() waitlistEntries?: WaitlistEntry;

    isInit = signal<boolean>(false);
    eventIncludes: EventIncludeOption[] = ["workflow", "reservations", "customers"];
    timeFormat: string;
    dateFormat: string;
    userName: string;
    userId: number;
    tableData: Table.DataSource;
    eventsData: EventData[];
    showWaitlistOnly: boolean = true;

    // Reactive filter state
    chosenEvent = signal<S25ItemI | undefined>(undefined);
    chosenDate = signal<S25ItemI | undefined>(undefined);
    groupingMode = signal<GroupingMode>(GroupingMode.None);

    viewModes = [
        { itemId: "waitlist", itemName: "Conflicts Only", val: "waitlist" },
        { itemId: "includedOtherAssignment", itemName: "All Assignment Tasks", val: "includedOtherAssignment" },
        { itemId: "includedAllOther", itemName: "Assignment and Notification Policy", val: "includedAllOther" },
    ];

    chosenViewMode = this.viewModes[0];
    viewMode = signal<string>(this.viewModes[0].val as string);

    taskItemsInit = signal<ManageWaitlistTaskInfo[]>([]);
    showWaitlistConfirm = signal<boolean>(false);
    clickWaitlistApprovedAll = signal<boolean>(false);
    pendingCompetingInfo = signal<TaskCompetingUtil.CompetingTasksInfo | null>(null);
    competingMessage = computed<string>(() => {
        const info = this.pendingCompetingInfo();
        if (!info) return "";
        return TaskCompetingUtil.getConfirmationMessage(info.count);
    });
    pendingTaskChanges = signal<TaskChange[]>([]);
    /** Tasks that triggered the competing-requests dialog (waitlist rows); used to build waitlist POST after deny. */
    pendingApproveTasksForWaitlist = signal<ManageWaitlistTaskInfo[]>([]);

    private readonly waitlistStore = inject(WaitlistStore);

    // Computed signal for filtered tasks
    taskItemsToDisplay = computed(() => {
        if (!this.taskItemsInit() || this.taskItemsInit().length === 0) return [];

        let data = [...this.taskItemsInit()];

        // Filter by event
        const selectedEventId = Number(this.chosenEvent()?.itemId);
        if (selectedEventId > 0) {
            data = data.filter((t) => Number(t.eventId) === selectedEventId);
        }

        // Filter by date
        const selectedDateItemId = this.chosenDate()?.itemId;
        if (selectedDateItemId) {
            data = data.filter((t) => S25Datefilter.transform(t.eventDate, this.dateFormat) === selectedDateItemId);
        }

        // Filter by view mode
        switch (this.viewMode()) {
            case "waitlist": {
                let conflictsOnly = data.filter((task) => task.waitinglistOrder !== "-");
                conflictsOnly = conflictsOnly.filter((task) => task.objectType !== Item.Ids.Resource);
                const locationScope = this.locationIdsForWaitlistScope();
                if (locationScope) {
                    conflictsOnly = conflictsOnly.filter(
                        (task) => task.objectType === Item.Ids.Location && locationScope.has(Number(task.item?.itemId)),
                    );
                }
                return conflictsOnly;
            }
            case "includedOtherAssignment":
                return data.filter((task) => [Item.Ids.Location, Item.Ids.Resource].includes(task.objectType));
            default:
                return data;
        }
    });

    // Computed signal to determine whether to show queue info message
    showQueueInfo = computed(() => {
        return this.viewMode() === "waitlist" && this.taskItemsToDisplay().some((t) => t.waitinglistOrder !== "-");
    });

    // Computed signal for unique location IDs in displayed tasks
    displayedLocationIds = computed(() => {
        const locationIds = new Set<number>(S25Util.array.forceArray<number[]>(this.data.itemIds).filter((id) => !!id));
        const tasks = this.taskItemsToDisplay();

        // Include location IDs from displayed tasks
        for (const task of tasks) {
            if (task.objectType === Item.Ids.Location && task.item?.itemId) {
                locationIds.add(task.item.itemId);
            }
        }

        return locationIds;
    });

    // Computed signal to determine shared location info
    sharedLocationInfo = computed(() => {
        const locationIds = this.displayedLocationIds();
        const sharedData = this.sharedLocationData();
        const sharedLocations: { id: number; name: string }[] = [];

        // Safety check: ensure sharedData is a valid Map before using it
        if (!sharedData || !(sharedData instanceof Map)) {
            return {
                hasSharedLocations: false,
                sharedLocations: [],
                message: "",
            };
        }

        for (const locationId of locationIds.values()) {
            const numericId = Number(locationId);
            const data = sharedData.get(numericId);
            if (data?.isShared) {
                // Only push if not already in sharedLocations
                const alreadyExists = sharedLocations.some((loc) => loc.id === numericId);
                if (!alreadyExists) {
                    sharedLocations.push({ id: numericId, name: data.name });
                }
            }
        }

        return {
            hasSharedLocations: sharedLocations.length > 0,
            sharedLocations,
            message: this.buildSharedLocationMessage(sharedLocations),
        };
    });

    staticItems = [
        {
            dropDownOrigName: "All Events",
            isSelected: true,
            itemId: 0,
            itemName: "All Events",
            noAnchorClick: true,
            txt: "All Events",
            val: "",
        },
    ];

    staticDateItems = [
        {
            dropDownOrigName: "All Dates",
            isSelected: true,
            itemId: 0,
            itemName: "All Dates",
            noAnchorClick: true,
            txt: "All Dates",
            val: "",
        },
    ];

    isInitData = signal<boolean>(false);

    datesList: S25ItemI[] = [];
    selectedItems = signal<number[]>([]);
    overlappedItems = signal<number[]>([]);

    // Shared location tracking
    sharedLocationData = signal<Map<number, { name: string; isShared: boolean }>>(new Map());

    eventTaskCompetesData: Task.MicroTaskWs[];

    constructor(
        private elementRef: ElementRef,
        private changeDetector: ChangeDetectorRef,
    ) {
        // Auto-refresh table when filters or grouping changes
        effect(() => {
            // Track all reactive dependencies
            this.chosenEvent();
            this.chosenDate();
            this.viewMode();
            this.groupingMode();

            // Refresh table if it's initialized
            if (this.tableComponent) {
                this.tableComponent.refresh();
            }
        });

        // Fetch shared location status when displayed locations change
        effect(() => {
            const locationIds = this.displayedLocationIds();
            if (locationIds.size > 0) {
                this.fetchSharedLocationStatus(locationIds);
            }
        });
    }

    async ngOnInit() {
        TelemetryService.send("Waitlist", "modalInit");
        if (!this.data.eventIds && this.data.waitlistEvents) {
            this.data.eventIds = this.data.waitlistEvents.map((item) => item.itemId).sort((a, b) => a - b);
        }

        const eventCompetesData = await TaskService.getMicroTasksByEventIds(
            S25Util.array.forceArray(this.data.eventIds),
            ["competes"],
        );
        this.eventTaskCompetesData = eventCompetesData;

        this.tableData = this.getTableConfig();
        this.isInit.set(true);
    }

    onChangeEventChoosen($event: S25ItemI) {
        this.chosenEvent.set($event);
        this.selectedItems.set([]);
        this.overlappedItems.set([]);
    }

    onChangeDateChoosen($event: S25ItemI) {
        this.chosenDate.set($event);
        this.selectedItems.set([]);
        this.overlappedItems.set([]);
    }

    onChangeViewMode($event: S25ItemI) {
        TelemetryService.sendWithSub("Waitlist", "ViewModeChanged", String($event.val));
        this.viewMode.set(String($event.val));
        this.selectedItems.set([]);
        this.overlappedItems.set([]);
    }

    onChangeGroupingMode($event: GroupingMode) {
        TelemetryService.sendWithSub("Waitlist", "GroupingModeChanged", String($event));
        this.groupingMode.set($event);
        this.selectedItems.set([]);
        this.overlappedItems.set([]);
    }

    @Bind
    async getRows(query: Table.UnpaginatedQuery): Promise<Table.DataSourceResponse> {
        // initData loads all data once; no need to re-fetch from the server
        if (!this.isInitData()) {
            if (query.forceRefresh) CacheRepository.invalidateByService("EventService");

            const { userName, userId, eventsData, dateFormat, timeFormat } = await this.getData();
            this.userName = userName;
            this.userId = userId;
            this.timeFormat = timeFormat;
            this.dateFormat = dateFormat;

            // flatten safely (handles nested array case)
            const flatEvents = S25Util.array.forceArray(eventsData).flat().filter(Boolean) as EventData[];
            this.taskItemsInit.set(await this.taskItems(flatEvents));

            // Get real tasks from events first
            const realTasks = await this.taskItems(flatEvents);

            // Only create fake tasks for waitlist events not in real tasks
            const nonApTasks = await this.convertWaitlistEventsToFakeTasks(
                this.data.waitlistEvents || [],
                realTasks, // Pass real tasks for filtering
            );

            const allTasks = [...realTasks, ...nonApTasks];

            this.taskItemsInit.set(allTasks);

            for (const item of this.taskItemsInit()) {
                const matchingWaitlistEvent = this.findWaitlistEventForReservation(item.reservationId);
                if (matchingWaitlistEvent) {
                    this.applyWaitlistEventToTask(item, matchingWaitlistEvent);
                    continue;
                }
                if (item.nonApTasks) continue;
                const waitlistData = this.getWaitlistData(item);
                item.waitinglistOrder = waitlistData.waitlistOrder;
                item.competingRsrvCount = waitlistData.competingRsrvCount;
                item.competes = waitlistData.competes;
            }

            this.applyWaitlistBlockingReservationMarkers();
            this.applyWaitlistOrderFromEvents();

            this.getAllEventDates();
            this.isInitData.set(true);
        }

        // Apply grouping based on selected mode
        let rows: Table.Row[];
        const displayedTasks = this.taskItemsToDisplay();
        switch (this.groupingMode()) {
            case GroupingMode.Conflicts:
                rows = this.getGroupedByconflicts();
                break;
            case GroupingMode.Events:
                rows = this.getGroupedByEvents();
                break;
            default:
                rows = this.getUngroupedRows();
        }

        return {
            rows: rows,
        };
    }

    @Bind
    mapToRow(item: ManageWaitlistTaskInfo): Table.Row {
        const taskNameCell =
            item.objectType === Item.Ids.Location
                ? {
                      component: S25ItemComponent,
                      inputs: {
                          includeTypeIcon: false,
                          itemTypeId: Item.Ids.Location,
                          itemId: item.item.itemId,
                          itemName: item.item.itemName,
                      },
                      textValue: item.item.itemName,
                  }
                : { text: item.name };

        const getOverlapClass = (item: ManageWaitlistTaskInfo) =>
            computed(() => {
                return this.overlappedItems().includes(item.id) ? "conflict-item-row" : "";
            });

        return {
            id: item.id,
            name: item.name,
            className: getOverlapClass(item)(),
            cells: {
                eventName: {
                    component: S25ItemComponent,
                    inputs: {
                        itemId: item.eventId,
                        itemTypeId: Item.Ids.Event,
                        itemName: item.eventName,
                    },
                    textValue: item.eventName,
                },
                occCount: { text: this.getOccCount(item.eventId) },
                taskDate: {
                    component: S25EditableDateComponent,
                    inputs: { val: item.eventDate, readOnly: true },
                    outputs: {
                        valChange: (val: string) => {
                            //just display date, do nothing here
                        },
                    },
                    textValue: item?.eventDate?.toString(),
                    sortValue: S25Util.date.toS25ISODateTimeStr(item.eventDate ?? undefined),
                },
                startTime: {
                    component: TaskTimeComponent,
                    inputs: {
                        eventStartInput: item.rsrvStartDate,
                        eventEndInput: item.rsrvEndDate,
                        isEndDateInput: false,
                    },
                    textValue: item?.rsrvStartDate?.toString(),
                    sortValue: S25Datefilter.transform(item.rsrvStartDate, this.timeFormat),
                },
                endTime: {
                    component: TaskTimeComponent,
                    inputs: {
                        eventStartInput: item.rsrvStartDate,
                        eventEndInput: item.rsrvEndDate,
                        isEndDateInput: true,
                    },
                    textValue: item?.rsrvEndDate?.toString(),
                    sortValue: S25Datefilter.transform(item.rsrvEndDate, this.timeFormat),
                },
                taskName: taskNameCell,
                status: !item.nonApTasks
                    ? {
                          component: S25TaskStatusComponent,
                          inputs: {
                              task: {
                                  task_blocked: item.taskBlocked,
                                  task_state: item.stateId,
                                  task_type: item.item.itemTypeId,
                                  blocking_task: item.blockTask,
                                  task_name: item.item.itemName,
                              },
                          },
                          textValue: item.state,
                      }
                    : {
                          text: "-",
                      },
                action: !item.nonApTasks
                    ? {
                          component: S25TaskActionComponent,
                          inputs: {
                              assignedToId: item.hasApproveDenyPerms ? this.userId : -999,
                              taskState: item.stateId,
                              taskId: item.id,
                              taskBlocked: S25Util.toBool(item.taskBlocked),
                              itemCount: item?.itemCount || 1,
                              taskType: item.type.typeId,
                              requesterId: item.requesterId,
                              eventId: item.eventId,
                              todoType: undefined,
                              todoSubType: undefined,
                              competes: item.competes,
                              objectType: item.objectType,
                              objectId: item.item.itemId,
                              reservationId: item.reservationId,
                          },
                      }
                    : {
                          text: "-",
                      },
                queuePosition: this.getQueuePositionCell(item),
                totalCompeting: this.getTotalCompetingCell(item),
            },
        };
    }

    getQueuePositionCell(item: ManageWaitlistTaskInfo): Table.Cell {
        if (item.waitinglistOrder === "Blocking") {
            const requestedName = item.blocksWaitlistForEventName?.trim();
            const label = requestedName ? `Blocking (${requestedName})` : "Blocking";
            return { text: label, sortValue: "998-blocking" };
        }
        if (item.waitinglistOrder === "-" || typeof item.waitinglistOrder !== "number") {
            return { text: "-", sortValue: "999" };
        }
        const position = item.waitinglistOrder;
        const ordinalSuffix = S25Util.getOrdinalSuffix(position);
        return {
            text: `${position}${ordinalSuffix}`,
            sortValue: position.toString().padStart(3, "0"),
        };
    }

    getTotalCompetingCell(item: ManageWaitlistTaskInfo): Table.Cell {
        if (item.waitinglistOrder === "Blocking" && item.competingRsrvCount) {
            const total = item.competingRsrvCount.toString();
            return { text: total, sortValue: total.padStart(3, "0") };
        }
        if (item.waitinglistOrder === "-" || !item.competingRsrvCount) {
            return { text: "-", sortValue: "0" };
        }
        const total = item.competingRsrvCount.toString();
        return {
            text: total,
            sortValue: total.padStart(3, "0"),
        };
    }

    getTableConfig(): Table.DataSource {
        return {
            type: "unpaginated",
            dataSource: this.getRows,
            columns: [
                {
                    id: "eventName",
                    header: "Event Name",
                },
                {
                    id: "occCount",
                    header: "# occurrences",
                },
                {
                    id: "taskDate",
                    header: "Occurrence Date",
                },
                {
                    id: "startTime",
                    header: "Start Time",
                    width: 80,
                },
                {
                    id: "endTime",
                    header: "End Time",
                    width: 80,
                },

                {
                    id: "taskName",
                    header: "Task Name",
                    width: 110,
                },

                {
                    id: "status",
                    header: "Status",
                },

                {
                    id: "action",
                    header: "Task Action",
                    sortable: false,
                },

                {
                    id: "queuePosition",
                    header: "Waitlist Order",
                },
                {
                    id: "totalCompeting",
                    header: "Total Waitlisted",
                },
            ],
        };
    }

    getData = async (): Promise<{
        userName: string;
        userId: number;
        eventsData: EventData[] | null;
        dateFormat: string;
        timeFormat: string;
    }> => {
        const eventIds = this.data.eventIds;
        const dataPromise: Promise<any> = eventIds?.length
            ? EventService.getEventsInclude(eventIds, this.eventIncludes, true, false, true)
            : Promise.resolve(null);

        let [userName, userId, eventsData, dateFormat, timeFormat] = await Promise.all([
            ContactService.getCurrentName(),
            ContactService.getCurrentId(),
            dataPromise,
            UserprefService.getS25Dateformat(),
            UserprefService.getS25Timeformat(),
        ]);
        eventsData = eventsData?.events?.event ?? [];
        this.eventsData = S25Util.array.forceArray(eventsData);

        return { userName, userId, eventsData, dateFormat, timeFormat };
    };

    /**
     * Space IDs from {@link ManageTaskData.itemIds} when the parent passes a non-empty list.
     * Used only to narrow **Conflicts only** ({@link viewMode} {@code waitlist}) rows in {@link taskItemsToDisplay}.
     */
    private locationIdsForWaitlistScope(): Set<number> | null {
        const ids = S25Util.array.forceArray(this.data.itemIds).filter((id) => S25Util.isDefined(id) && Number(id) > 0);
        if (!ids.length) {
            return null;
        }
        return new Set(ids.map((id) => Number(id)));
    }

    async taskItems(eventsData: EventData[]) {
        const tasks: ManageWaitlistTaskInfo[] = [];
        for (const eventData of eventsData) {
            if (eventData.approval) {
                const eventTaskItems: ManageWaitlistTaskInfo[] = await TaskUtil.getEventTasks(eventData, this.userId);
                tasks.push(...eventTaskItems);
            }
        }
        return tasks;
    }

    private findWaitlistEventForReservation(reservationId: number | undefined): EventReqInfo | undefined {
        if (!S25Util.isDefined(reservationId)) return undefined;
        return this.data.waitlistEvents?.find((event) => Number(event.rsrvId) === Number(reservationId));
    }

    private numericWaitlistOrder(waitlistOrder: number | string | null | undefined): number | undefined {
        if (waitlistOrder == null) return undefined;
        const numericOrder = Number(waitlistOrder);
        return Number.isFinite(numericOrder) && numericOrder > 0 ? numericOrder : undefined;
    }

    private applyWaitlistEventToTask(task: ManageWaitlistTaskInfo, waitlistEvent: EventReqInfo): void {
        const numericOrder = this.numericWaitlistOrder(waitlistEvent.waitlistOrder);
        if (numericOrder != null) {
            task.waitinglistOrder = numericOrder;
        }
        if (waitlistEvent.competingRsrvCount != null) {
            task.competingRsrvCount = Number(waitlistEvent.competingRsrvCount);
        }
        const spaceCompetes = waitlistEvent.competes?.spaceCompetes;
        if (spaceCompetes?.length) {
            task.competes = [...spaceCompetes];
        }
    }

    /** Parent views (e.g. weekly availability) pass queue position via {@link EventReqInfo}; re-apply after blocking markers. */
    private applyWaitlistOrderFromEvents(): void {
        for (const task of this.taskItemsInit()) {
            if (task.waitinglistOrder === "Blocking") continue;
            const matchingWaitlistEvent = this.findWaitlistEventForReservation(task.reservationId);
            if (!matchingWaitlistEvent) continue;
            this.applyWaitlistEventToTask(task, matchingWaitlistEvent);
        }
    }

    /**
     * Real assignment tasks for confirmed/other reservations never match {@link EventReqInfo} by rsrvId
     * (those rows describe the requested waitlist side only). Mark tasks that appear as
     * {@link Task.SpaceCompete.conflictRsrvId} so **Conflicts only** includes blocking reservations.
     */
    private applyWaitlistBlockingReservationMarkers(): void {
        const waitlistEvents = this.data.waitlistEvents ?? [];
        for (const waitlistEvent of waitlistEvents) {
            const spaceCompetes = waitlistEvent.competes?.spaceCompetes;
            if (!spaceCompetes?.length) continue;

            for (const compete of spaceCompetes) {
                const conflictReservationId = Number(compete.conflictRsrvId);
                const spaceId = Number(compete.spaceId);
                if (!Number.isFinite(conflictReservationId) || !Number.isFinite(spaceId)) continue;

                for (const task of this.taskItemsInit()) {
                    if (task.nonApTasks) continue;
                    if (task.objectType !== Item.Ids.Location) continue;
                    if (Number(task.reservationId) !== conflictReservationId) continue;
                    if (Number(task.item?.itemId) !== spaceId) continue;
                    if (typeof task.waitinglistOrder === "number") continue;
                    if (task.waitinglistOrder === "Blocking") continue;

                    task.waitinglistOrder = "Blocking";
                    task.blocksWaitlistForEventName = waitlistEvent.itemName;
                    task.competingRsrvCount = waitlistEvent.competingRsrvCount ?? task.competingRsrvCount;
                    if (!task.competes?.length) {
                        task.competes = [...spaceCompetes];
                    }
                    break;
                }
            }
        }
    }

    getWaitlistData(task: ManageWaitlistTaskInfo): {
        waitlistOrder: string | number;
        competingRsrvCount: number;
        competes: Task.SpaceCompete[];
    } {
        // competes data for waitlist
        const found = this.eventTaskCompetesData.find(
            (t: Task.MicroTaskWs) =>
                t.id === task.id &&
                task.objectType === Item.Ids.Location &&
                t.objectId === task.item.itemId &&
                t.competes?.some((c) => c.spaceCompetes?.length > 0),
        );

        const competesDataInit = found?.competes?.flatMap((c) => c.spaceCompetes) || [];
        let competesData: Task.SpaceCompete[] = [];
        // included  current task to display waitlist order
        if (competesDataInit.length > 0) {
            competesData = [
                ...(competesDataInit ?? []),
                {
                    spaceId: task?.item.itemId,
                    conflictType: "req_rsrv",
                    conflictId: task.eventId,
                    conflictRsrvId: task.reservationId as number,
                    conflictName: task.eventName,
                    conflictEvStartDt: task.rsrvStartDate
                        ? (S25Util.date.toS25ISODateTimeStr(new Date(task.rsrvStartDate)) as ISODateString)
                        : undefined,
                    conflictEvEndDt: task.rsrvEndDate
                        ? (S25Util.date.toS25ISODateTimeStr(new Date(task.rsrvEndDate)) as ISODateString)
                        : undefined,
                },
            ].sort((a, b) => a.conflictRsrvId - b.conflictRsrvId);
        }
        const waitlistIndex = competesData.findIndex((item) => item.conflictRsrvId === task.reservationId) + 1;
        const waitlistOrder: number | string = competesData.length === 0 ? "-" : waitlistIndex;
        const competingRsrvCount = competesData.length;

        return { waitlistOrder, competingRsrvCount, competes: competesDataInit };
    }

    getOccCount(eventId: number): number {
        const event = this.eventsData.find((e) => e.event_id === eventId);
        if (!event || !event.profile) return 0;

        const profiles = S25Util.array.forceArray(event.profile);

        return profiles.reduce((acc, p) => {
            const reservations = S25Util.array.forceArray(p?.reservation);
            return acc + reservations.length;
        }, 0);
    }

    getAllReservationStartDates(): string[] {
        return this.eventsData.flatMap((event) =>
            S25Util.array.forceArray(event.profile).flatMap((profile) =>
                S25Util.array
                    .forceArray(profile.reservation)
                    .map((res) => res.event_start_dt)
                    .filter(Boolean),
            ),
        );
    }

    getAllEventDates(): void {
        const datesList = this.taskItemsInit()
            .filter((item) => item.eventDate != null)
            .map((item) => new Date(item.eventDate!))
            .filter((date) => !isNaN(date.getTime()))
            .map((validDate) => S25Datefilter.transform(validDate, this.dateFormat));

        const uniqueDatesList = [...new Set(datesList)];

        this.datesList = uniqueDatesList.map((date) => ({
            itemId: date,
            itemName: date,
        }));
    }

    /**
     * Fetch shared location status for the given location IDs
     */
    async fetchSharedLocationStatus(locationIds: Set<number>): Promise<void> {
        try {
            const sharedData = await SpaceService.getSpacesAlwaysShared(Array.from(locationIds));

            //build a map for the shared lcations
            const sharedLocationMap = new Map<number, { name: string; isShared: boolean }>();
            for (const space of sharedData) {
                sharedLocationMap.set(space.itemId, {
                    name: space.itemName,
                    isShared: space.isShared,
                });
            }
            this.sharedLocationData.set(sharedLocationMap);
        } catch (error) {
            console.error("Failed to fetch shared location status:", error);
        }
    }

    /**
     * Build a message about shared locations
     */
    buildSharedLocationMessage(sharedLocations: { id: number; name: string }[]): string {
        if (sharedLocations.length === 0) {
            return "";
        }

        if (sharedLocations.length === 1) {
            return `${sharedLocations[0].name} is configured as a shared location. Events in shared locations are expected to overlap, so no conflicts will be shown even when events overlap.`;
        }

        const locationNames = sharedLocations.map((loc) => loc.name).join(", ");
        return `The following locations are configured as shared: ${locationNames}. Events in shared locations are expected to overlap, so no conflicts will be shown even when events overlap.`;
    }

    isUngrouped(task: ManageWaitlistTaskInfo) {
        return task.item.itemTypeId !== Item.Ids.Location || task.waitinglistOrder === "-";
    }

    selectedChange(selectItem: Set<Table.Row["id"]>) {
        const selectedItem: number[] = Array.from(selectItem) as number[];
        const ret: number[] = [];
        let count = 0;

        //check select item has hasApproveDenyPerms
        jSith.forEach(selectedItem, (key, i) => {
            const find = this.taskItemsInit().find((f: any) => {
                return i && f.hasApproveDenyPerms === true && f.id === i;
            });
            if (find) {
                ret.push(i);
            } else {
                count++, this.tableComponent.selected.delete(i);
            }
            return ret;
        });

        this.selectedItems.set(ret);

        count > 0 ? alert("You do not have permission to approve or deny on one or more of the selected tasks!") : "";
    }

    async onTaskButtonRefresh() {
        //await this.resetF();
    }

    approve() {
        this.onActionClick(Task.States.Assigned);
    }

    deny() {
        this.onActionClick(Task.States.Denied);
    }

    async onActionClick(action: Task.State) {
        this.setLoading(true);

        const selectedIds = this.selectedItems();
        const displayedTasks = this.taskItemsToDisplay();

        // 1. Build taskChangeSet and matchedSet using reduce
        const matchedTasks = displayedTasks
            .filter((task) => selectedIds.includes(task.id))
            .reduce(
                (acc, task) => {
                    acc.taskChangeSet.push({
                        eventId: task.eventId,
                        itemId: task.id,
                        itemTypeId: task.item?.itemTypeId,
                        objectType: task.objectType,
                        objectId: task.item?.itemId,
                        itemStateId: task.stateId,
                        isTodo: false,
                    });

                    if (task.waitinglistOrder !== "-") {
                        acc.matchedSet.push(task);
                    }

                    return acc;
                },
                {
                    taskChangeSet: [] as TaskChange[],
                    matchedSet: [] as ManageWaitlistTaskInfo[],
                },
            );

        // 2. Handle competing tasks for ASSIGNED action
        if (action === Task.States.Assigned) {
            // Check for waitlist overlaps within selected tasks
            const overlappingWlItemIds = TaskCompetingUtil.findWaitlistOverlaps(matchedTasks.matchedSet);

            if (overlappingWlItemIds?.length > 0) {
                this.handleOverlapConflict(
                    overlappingWlItemIds,
                    "Unable to approve selected items. Some items conflict with each other in the waitlist.",
                );
                return;
            }

            // Analyze competing tasks
            const allCompetes = matchedTasks.matchedSet.flatMap((task) => task.competes || []);
            const competingTaskChanges = TaskCompetingUtil.buildDeniedTaskChanges(
                this.taskItemsToDisplay(),
                allCompetes,
            );

            // Deduplicate competing tasks
            const deniedMap = new Map(competingTaskChanges.map((item) => [`${item.eventId}_${item.itemId}`, item]));
            const uniqueCompetingTasks = Array.from(deniedMap.values());

            // Check if any competing tasks are also in the selected tasks (conflict)
            const matchedKeySet = new Set(matchedTasks.taskChangeSet.map((task) => `${task.eventId}_${task.itemId}`));
            const overlappingItemIds: number[] = uniqueCompetingTasks
                .filter((denied) => matchedKeySet.has(`${denied.eventId}_${denied.itemId}`))
                .map((denied) => denied.itemId);

            if (overlappingItemIds.length > 0) {
                this.handleOverlapConflict(
                    overlappingItemIds,
                    "Unable to approve selected items. Some items conflict with other selected items.",
                );
                return;
            }

            // If there are competing tasks, show confirmation dialog
            if (uniqueCompetingTasks.length > 0) {
                const competingInfo: TaskCompetingUtil.CompetingTasksInfo = {
                    hasCompetingTasks: true,
                    count: uniqueCompetingTasks.length,
                    tasksToNotify: uniqueCompetingTasks,
                    competingEventIds: Array.from(new Set(uniqueCompetingTasks.map((t) => t.eventId))),
                };

                this.pendingCompetingInfo.set(competingInfo);
                this.pendingTaskChanges.set(matchedTasks.taskChangeSet);
                this.pendingApproveTasksForWaitlist.set(matchedTasks.matchedSet);
                this.clickWaitlistApprovedAll.set(true);
                this.showWaitlistConfirm.set(true);
                this.setLoading(false);
                return;
            }
        }

        // 3. No competing tasks or denying - proceed directly
        this.pendingApproveTasksForWaitlist.set([]);
        await this.executeTaskChange(matchedTasks.taskChangeSet, action);
    }

    /**
     * Execute the task change with optional competing task denial
     */
    async executeTaskChange(
        taskChanges: TaskChange[],
        action: Task.State,
        competingAction: TaskCompetingUtil.CompetingAction = "skip",
    ) {
        const competingInfo = this.pendingCompetingInfo();

        if (action === Task.States.Assigned && competingInfo?.hasCompetingTasks) {
            const waitlistOptions: TaskCompetingUtil.BatchWaitlistPayload | undefined =
                competingAction === "waitlist"
                    ? {
                          waitlistStore: this.waitlistStore,
                          requests: TaskCompetingUtil.buildWaitlistRequestsForApprovedLocationTasks(
                              this.pendingApproveTasksForWaitlist().map((task) => ({
                                  eventId: task.eventId,
                                  reservationId: task.reservationId,
                                  spaceId: task.item.itemId,
                                  competes: task.competes ?? [],
                              })),
                          ),
                      }
                    : undefined;

            const resp = await TaskCompetingUtil.approveWithOptionalDenial(
                taskChanges,
                competingInfo,
                competingAction,
                waitlistOptions,
            );

            if (resp.error) {
                S25Util.showError(resp.error, "Task update failed.");
            } else {
                await this.refresh();
            }
        } else {
            const [resp, err] = await S25Util.Maybe(TaskService.changeTask(taskChanges, action));

            if (resp) {
                await this.refresh();
            }

            if (err) {
                S25Util.showError(err, "Task update failed.");
            }
        }

        this.setLoading(false);
        this.pendingApproveTasksForWaitlist.set([]);
    }

    async handleCompetingConfirm(action: TaskCompetingUtil.CompetingAction) {
        this.showWaitlistConfirm.set(false);
        this.clickWaitlistApprovedAll.set(false);

        const taskChanges = this.pendingTaskChanges();
        await this.executeTaskChange(taskChanges, Task.States.Assigned, action);

        this.pendingCompetingInfo.set(null);
        this.pendingTaskChanges.set([]);
        this.pendingApproveTasksForWaitlist.set([]);
    }

    /**
     * Cancel the competing tasks confirmation
     */
    cancelCompetingConfirm() {
        this.showWaitlistConfirm.set(false);
        this.clickWaitlistApprovedAll.set(false);
        this.pendingCompetingInfo.set(null);
        this.pendingTaskChanges.set([]);
        this.pendingApproveTasksForWaitlist.set([]);
        this.setLoading(false);
    }

    isOverlapItem(item: ManageWaitlistTaskInfo): boolean {
        if (this.overlappedItems().length === 0) return false;
        return this.overlappedItems().includes(item.id);
    }

    async handleOverlapConflict(itemIds: number[], message: string) {
        this.overlappedItems.set(itemIds);
        this.getUngroupedRows();
        alert(message);
        this.setLoading(false);
        await S25Util.delay(60);
        this.tableComponent.selected = new Set(this.selectedItems());
        this.tableComponent.detectChanges();
    }

    async refresh() {
        this.isInitData.set(false); // force data to reload
        // force a data refresh, no luck with this.tableComponent.refresh(true) on actionComponent,
        const newData = await this.getRows({ forceRefresh: true });
        this.tableComponent.rows = newData.rows; // update table rows directly
        this.tableComponent.detectChanges();
        this.changeDetector.detectChanges();
    }

    setLoading(yes: boolean) {
        if (yes) {
            S25LoadingApi.init(this.elementRef.nativeElement);
        } else {
            S25LoadingApi.destroy(this.elementRef.nativeElement);
        }
        this.changeDetector.detectChanges();
    }
    /**
     * Group tasks by conflicts (waitlist queues) with template-based expandable rows.
     * Shows first reservation in queue; expanding shows competing reservations in a custom template.
     */
    @Bind
    getGroupedByconflicts(): Table.Row[] {
        // Group tasks by location/date/time conflict (waitlist queue)
        const conflictGroups = new Map<string, ManageWaitlistTaskInfo[]>();
        const displayedTasks = this.taskItemsToDisplay();

        for (const task of displayedTasks) {
            // Only group location tasks that have waitlist order
            if (task.item.itemTypeId === Item.Ids.Location && task.waitinglistOrder !== "-") {
                // Create a unique key for each conflict (location + date)
                const conflictKey = `${task.item.itemId}_${task.eventDate ? new Date(task.eventDate).toDateString() : "unknown"}`;

                if (!conflictGroups.has(conflictKey)) {
                    conflictGroups.set(conflictKey, []);
                }
                conflictGroups.get(conflictKey)!.push(task);
            }
        }

        const rows: Table.Row[] = [];

        // For each conflict group, create an expandable row with template
        conflictGroups.forEach((tasks, conflictKey) => {
            // Sort by waitlist order
            tasks.sort((a, b) => {
                const orderA = typeof a.waitinglistOrder === "number" ? a.waitinglistOrder : 999;
                const orderB = typeof b.waitinglistOrder === "number" ? b.waitinglistOrder : 999;
                return orderA - orderB;
            });

            const totalInQueue = tasks.length;

            // First task in the queue is the main row
            const firstTask = tasks[0];
            const competingTasks = tasks.slice(1);

            const mainRow = this.mapToRow(firstTask);

            // Update the queue columns to show position and total separately
            mainRow.cells.queuePosition = this.getQueuePositionCell(firstTask);
            mainRow.cells.totalCompeting = this.getTotalCompetingCell(firstTask);

            // If there are competing reservations, make it expandable with auto-generated rows
            if (competingTasks.length > 0) {
                mainRow.expandable = true;
                mainRow.expandedContent = {
                    expandAsRows: true,
                    rows: competingTasks.map((task, index) => {
                        const childRow = this.mapToRow(task);
                        childRow.className = "child-row";
                        // Update the queue columns to show position and total separately
                        childRow.cells.queuePosition = this.getQueuePositionCell(task);
                        childRow.cells.totalCompeting = this.getTotalCompetingCell(task);
                        return childRow;
                    }),
                };
            }

            rows.push(mainRow);
        });

        // Add non-location tasks that aren't grouped
        const nonGroupedTasks = displayedTasks.filter(
            (task) => task.item.itemTypeId !== Item.Ids.Location || task.waitinglistOrder === "-",
        );

        rows.push(...nonGroupedTasks.map((task) => this.mapToRow(task)));

        return rows;
    }

    /**
     * Group tasks by event/reservation.
     * Shows one row per event; expanding shows all reservations with task action and queue order.
     */
    @Bind
    getGroupedByEvents(): Table.Row[] {
        // Group tasks by event
        const eventGroups = new Map<number, ManageWaitlistTaskInfo[]>();
        const displayedTasks = this.taskItemsToDisplay();

        for (const task of displayedTasks) {
            if (!eventGroups.has(task.eventId)) {
                eventGroups.set(task.eventId, []);
            }
            eventGroups.get(task.eventId)!.push(task);
        }

        const rows: Table.Row[] = [];

        // For each event, create an expandable row
        eventGroups.forEach((rsrvTask, eventId) => {
            //sort reservations by event start date
            const sortedRsrvTask = rsrvTask.sort((a, b) => {
                //EventDate really is reservation date in this context
                if (a.eventDate && b.eventDate) {
                    return a.eventDate.getTime() - b.eventDate.getTime();
                } else {
                    return 0;
                }
            });

            const firstTask = sortedRsrvTask[0];

            // Create a summary row for the event
            const summaryRow: Table.Row = {
                id: `event-${eventId}`,
                name: firstTask.eventName,
                expandable: true,
                cells: {
                    eventName: {
                        component: S25ItemComponent,
                        inputs: {
                            itemId: eventId,
                            itemTypeId: Item.Ids.Event,
                            itemName: firstTask.eventName,
                        },
                        textValue: firstTask.eventName,
                    },
                    occCount: { text: this.getOccCount(eventId) },
                    taskDate: {
                        component: S25EditableDateComponent,
                        inputs: { val: firstTask.eventDate, readOnly: true },
                        textValue: firstTask?.eventDate?.toString(),
                        sortValue: firstTask.eventDate ? S25Util.date.toS25ISODateTimeStr(firstTask.eventDate) : "",
                    },
                    taskName: {
                        text: `${rsrvTask.length} reservation${rsrvTask.length !== 1 ? "s" : ""}`,
                    },
                    action: {
                        text: "Click to expand",
                    },
                    queuePosition: {
                        text: "-",
                    },
                    totalCompeting: {
                        text: "-",
                    },
                },
                expandedContent: {
                    expandAsRows: true,
                    rows: sortedRsrvTask.map((task) => {
                        const childRow = this.mapToRow(task);
                        childRow.className = "child-row";
                        childRow.cells.queuePosition = this.getQueuePositionCell(task);
                        childRow.cells.totalCompeting = this.getTotalCompetingCell(task);
                        return childRow;
                    }),
                },
            };

            rows.push(summaryRow);
        });

        return rows;
    }

    /**
     * Get ungrouped rows (for 'none' grouping mode)
     */
    @Bind
    getUngroupedRows(): Table.Row[] {
        const displayedTasks = this.taskItemsToDisplay();
        return displayedTasks.map((item) => this.mapToRow(item)) || [];
    }

    /**
     * Convert EventReqInfo (from waitlistEvents) to noAPTasks ManageWaitlistTaskInfo
     * for events that don't have actual tasks but should still be displayed
     */
    private async convertWaitlistEventToFakeTask(
        waitlistEvent: EventReqInfo,
        spaceName?: string,
    ): Promise<ManageWaitlistTaskInfo> {
        // Fetch space name if not provided and objectId exists
        const itemName = spaceName || `Location ${waitlistEvent.objectId}`;

        // Use negative ID to avoid conflicts with real task IDs
        // Or use rsrvId if you want to identify by reservation
        const fakeTaskId = -(waitlistEvent.rsrvId || waitlistEvent.itemId);

        return {
            comment: "",
            id: fakeTaskId,
            name: itemName, // Space/location name
            state: "Requested", // Default state for waitlist entries
            stateId: Task.States.InProgress, // Or appropriate state
            type: {
                typeId: Item.Ids.Location, // Assuming location type
            },
            flagged: "",
            assignedTo: "",
            assignedToIds: [],
            object: itemName,
            respondByDate: null,
            firstDate: waitlistEvent.eventDate ? new Date(waitlistEvent.eventDate) : null,
            eventName: waitlistEvent.itemName,
            eventId: waitlistEvent.itemId,
            eventDate: waitlistEvent.eventDate ? new Date(waitlistEvent.eventDate) : null,
            item: {
                itemId: waitlistEvent.objectId,
                itemName: itemName,
                itemTypeId: Item.Ids.Location, // Or determine from context
            },
            objectType: Item.Ids.Location,
            hasApproveDenyPerms: false, // No task = no permissions
            taskBlocked: "F",
            blockTask: [],
            workflowChained: false,
            requesterId: null,
            waitinglistOrder: this.numericWaitlistOrder(waitlistEvent.waitlistOrder) ?? "-",
            competingRsrvCount: waitlistEvent.competingRsrvCount ?? 0,
            competes: waitlistEvent.competes?.spaceCompetes || [],
            reservationId: waitlistEvent.rsrvId,
            rsrvStartDate: waitlistEvent.dates?.start
                ? typeof waitlistEvent.dates.start === "string"
                    ? new Date(waitlistEvent.dates.start)
                    : new Date(waitlistEvent.dates.start)
                : undefined,
            rsrvEndDate: waitlistEvent.dates?.end
                ? typeof waitlistEvent.dates.end === "string"
                    ? new Date(waitlistEvent.dates.end)
                    : new Date(waitlistEvent.dates.end)
                : undefined,
            nonApTasks: true,
        };
    }

    /**
     * Convert multiple waitlist events to noAPTasks tasks
     */
    private async convertWaitlistEventsToFakeTasks(
        waitlistEvents: EventReqInfo[],
        realTasks: ManageWaitlistTaskInfo[], // Add this parameter
    ): Promise<ManageWaitlistTaskInfo[]> {
        // Get set of reservation IDs already in real tasks
        const realTaskRsrvIds = new Set(
            realTasks
                .map((task) => Number(task.reservationId))
                .filter((reservationId) => Number.isFinite(reservationId)),
        );

        // Filter out waitlist events that already have a real task
        const eventsNeedingFakeTasks = waitlistEvents.filter((event) => {
            const rsrvId = Number(event.rsrvId);
            return Number.isFinite(rsrvId) && !realTaskRsrvIds.has(rsrvId);
        });

        // Batch fetch space names for efficiency
        const spaceIds = eventsNeedingFakeTasks
            .map((e) => e.objectId)
            .filter((id): id is number => id !== undefined && id > 0);

        const uniqueSpaceIds = [...new Set(spaceIds)];
        const spaceNamesMap = new Map<number, string>();

        if (uniqueSpaceIds.length > 0) {
            const spaces = await SpaceService.getSpacesMinimal(uniqueSpaceIds);
            for (const space of spaces) {
                if (space.space_id != null && space.space_name != null)
                    spaceNamesMap.set(space.space_id, space.space_name);
            }
        }

        return Promise.all(
            eventsNeedingFakeTasks.map((event) =>
                this.convertWaitlistEventToFakeTask(event, spaceNamesMap.get(event.objectId)),
            ),
        );
    }

    @Bind
    async onDeleteClick(item: ManageWaitlistTaskInfo) {
        const yes = await this.deleteNonApTasksModal.open();
        if (yes) {
            await this.tableComponent.refresh();
        }
    }

    GroupingMode = GroupingMode;
}

export interface ManageWaitlistTaskInfo {
    comment: string;
    id: number;
    name: string;
    state: string;
    stateId: number;
    type: TypeInfo;
    flagged?: CharBoolean | string;
    assignedTo: string;
    assignedToIds: Array<string | number>;
    object: string;
    respondByDate: Date | null;
    firstDate: Date | null;
    eventName: string;
    eventId: number;
    eventDate: Date | null;
    item: {
        itemId: number;
        itemName: string;
        itemTypeId: number;
    };
    objectType: number;
    hasApproveDenyPerms: boolean;
    taskBlocked: string;
    blockTask?: Task.wsBlocked[];
    workflowChained?: boolean;
    requesterId: number | null;
    waitinglistOrder?: number | null | string;
    /** When {@link waitinglistOrder} is {@code "Blocking"}, the requested event name this reservation blocks. */
    blocksWaitlistForEventName?: string;
    competingRsrvCount?: number; // Total number of competing reservations
    itemCount?: number;
    competes?: Task.SpaceCompete[];
    reservationId?: number;
    rsrvStartDate?: ISODateString | Date;
    rsrvEndDate?: ISODateString | Date;
    nonApTasks?: boolean;
}

interface TypeInfo {
    typeId: string | number;
    [key: string]: unknown;
}
